import { useSafeAppConnection } from '@gnosis.pm/safe-apps-web3-react';
import { useWeb3React } from '@web3-react/core';
import { useContext, useEffect, useState } from 'react';
import { SupportedConnectors } from '../../config/constants';
import connectionContext from '../../context/connection/connectionContext';
import { fox, gnosisSafe, injected } from '../../web3/connectors';

const useAutoConnect = () => {
    const [tried, setTried] = useState(false);

    const { active } = useWeb3React();
    const { activateWallet } = useContext(connectionContext);

    const triedToConnectToSafe = useSafeAppConnection(gnosisSafe);

    useEffect(() => {
        if (!active && triedToConnectToSafe) {
            (async () => {
                const isAuthorized = await injected.isAuthorized();

                if ((window as any).foxwallet) {
                    activateWallet(SupportedConnectors.FOX, fox);
                    return;
                }
                if (isAuthorized) {
                    activateWallet(SupportedConnectors.METAMASK, injected);
                } else {
                    setTried(true);
                }
            })();
        }
    }, [triedToConnectToSafe, active, activateWallet]);

    useEffect(() => {
        if (active) {
            setTried(true);
        }
    }, [active]);

    return tried;
};

export default useAutoConnect;
